import recordLabel from "data/selectors/recordLabel";

class StereotypeProjection {

    constructor(stereoInfo, entityProxy) {
        this.stereoInfo = stereoInfo;
        this.entityProxy = entityProxy;
        // todo: use an index, not a scan
        this.impl = stereoInfo.implementations.find(it =>
            it.key === this.entityProxy.entityKey);
        if (this.impl == null) {
            throw new Error(`Entity '${this.entityProxy.entityKey}' doesn't implement '${this.stereoInfo.key}'`);
        }
    }

    get(field) {
        // todo: use an index, not a scan
        const fi = this.impl.fieldImpls.find(it =>
            it.key === field);
        if (fi == null) return null; // no field def provided
        return fi.script(this.entityProxy);
    }

    getKey() {
        return this.stereoInfo.key + "[" + this.entityProxy.entityKey + "]#" + this.entityProxy.id;
    }

    equals(o) {
        if (o == null) return false;
        if (!(o instanceof StereotypeProjection)) return false;
        if (this.stereoInfo.key !== o.stereoInfo.key) return false;
        if (!this.entityProxy.equals(o.entityProxy)) return false;
        return true;
    }

    getLabel() {
        return recordLabel(this.stereoInfo, this);
    }

}

export default StereotypeProjection;



// WEBPACK FOOTER //
// ./app/data/util/StereotypeProjection.js